<template>
  <div :class="elementClass" v-text="text">
    <slot></slot>
  </div>
</template>

<script>
import { avatarClass } from "../prefix";
export default {
  props: {
    firstName: String,
    type: String,
  },
  computed: {
    elementClass() {
      let text = avatarClass;
      if (this.type) text += ` ${this.type}`;
      return text;
    },
    text() {
      if (!this.firstName) return "";
      return this.firstName.charAt(0);
    },
  },
};
</script>

<style lang="scss">
@import "../scss/import.scss";
$element: $prefix + "-avatar";

#{$element} {
  background: $color-grey-200;
  width: 48px;
  height: 48px;
  border-radius: 50%;
  display: inline-block;
  vertical-align: middle;
  line-height: 24px;
  text-align: center;
  padding: 12px;
  color: $color-grey-500;

  &.small {
    width: 40px;
    height: 40px;
    padding: 8px;
  }

  &.extra-small {
    width: 36px;
    height: 36px;
    padding: 6px;
  }
}
</style>
